import {useMutation} from "@apollo/client";
import pluralize from "pluralize";

import {FormModal} from "@/components/form/overlay/FormModal.tsx";
import {GQL_UPDATE_ESCALATIONS_STATE} from "@/lib/queries/checks.ts";
import {GraphQLResponse, ResponseStatus} from "@/lib/types/common.ts";
import {BulkSetEscalationsForm} from "@/pages/checks/list/actions/bulkSetEscalations/BulkSetEscalationsForm.tsx";
import {CheckEscalationFormValues} from "@/pages/checks/update/sections/CheckEscalationForm.tsx";

export interface BulkSetEscalationsModalProps {
  selectedItemsIds: number[];
  show: boolean;
  setShow: (show: boolean) => void;
  onSuccess: () => void;
}

export const BulkSetEscalationsModal = ({selectedItemsIds, show, setShow, onSuccess}: BulkSetEscalationsModalProps) => {
  const [updateChecksEscalations, {data, loading}] = useMutation<GraphQLResponse<null>>(GQL_UPDATE_ESCALATIONS_STATE);

  const handleSubmit = async (data: CheckEscalationFormValues) => {
    const response = await updateChecksEscalations({
      variables: {
        ids: selectedItemsIds,
        escalations: data.escalations,
      },
    });
    if (response.data?.response.status === ResponseStatus.SUCCESS) {
      setShow(false);
      onSuccess();
    }
  };

  const formId = "BulkSetEscalationsForm";
  return (
    <FormModal
      size="lg"
      disabled={loading}
      formId={formId}
      onCancel={() => setShow(false)}
      show={show}
      title={`Set Escalations on ${pluralize("Check", selectedItemsIds.length, true)}`}
    >
      <BulkSetEscalationsForm
        formId={formId}
        onSubmit={handleSubmit}
        serverErrors={data?.response?.status === ResponseStatus.ERROR ? data.response.message : undefined}
        onError={console.log}
      />
    </FormModal>
  );
};
